/**
 * created by xcc  2022/4/21
 * 用户管理路由
 */
import NewUserManagement from "../pms/NewUserManagement";   //媒体管理

export  const  newUserManageRouter =[
    {
        path: "/view/pms/newUserManageRouter",
        componentTitle:'pms用户管理',
        component: NewUserManagement
    }
];

